import { isEqual, sortBy } from 'lodash';
import { swup } from '../main';
import Cookies from 'js-cookie';

export const productFiltering = (() => {
	const instance = {
		elements: [],
		view: Cookies.get('shop-view') ? Cookies.get('shop-view') : 'grid',
	}

	instance.setNewView = (newView) => {
		instance.view = newView;
		Cookies.set('shop-view', newView);
	}

	instance.checkFiltersForFilter = (filterObj) => {
		return instance.activeFilters.filter((group) => {
			return group.filters.filter((activeFilter) => {
				return isEqual(activeFilter, filterObj)
			}).length
		}).length
	}

	instance.checkFiltersForType = (activeFilters, type) => {
		return activeFilters.filter((group) => {
			return group.name === type;
		}).length
	}

	instance.getSortby = () => {
		let activeFilters = [];

		instance.sortTriggers.forEach((button) => {
			const filterActive = button.checked;

			const type = button.getAttribute('data-type') || null;
			const name = button.getAttribute('value') || null;

			let filterObj = { name, type }

			if(filterActive) {
				activeFilters.push({
					name: 'sortby',
					filters: [filterObj],
				});
			}
		});

		return activeFilters;
	}

	instance.getActiveFilters = () => {
		let activeFilters = [];

		instance.filterTriggers.forEach((button) => {
			const filterActive = button.checked;

			const type = button.getAttribute('data-type') || null;
			const name = button.getAttribute('value') || null;
			const nameText = button.labels[0].textContent.trim() || null;

			let filterObj = { name, type }

			if(filterActive) {

				window.dataLayer.push({
					event: 'custom.list.filter',
					action: 'filter_selected',
					name: nameText,
					type,
				});	
				
				instance.addFilter(activeFilters, filterObj);
			}
		});

		return activeFilters;
	}

	// TODO: name is misleading - suggests filters are being added to the instance. Refactor.
	instance.addFilter = (activeFilters, filterObj) => {
		if(instance.checkFiltersForType(activeFilters, filterObj.type)) {
			activeFilters.forEach((group) => {
				if(group.name === filterObj.type)
				{
					group.filters.push(filterObj)
				}
			})
		} else {
			activeFilters.push({
				name: filterObj.type,
				filters: [filterObj],
			});
		}		

		return activeFilters;
	}

	instance.applyFilters = () => {
		let filters = instance.getActiveFilters();
		let sortby = instance.getSortby();

		const activeFilters = [...filters, ...sortby];

		// instance.blockUI();
		instance.createFilterURL(activeFilters);
	}

	instance.blockUI = () => {
		// document.body.classList.add('filtering-product');

		setTimeout(() => window.scrollTo({top: 0, behavior: 'smooth'}), 200 );

		instance.filterTriggers.forEach((button) => {
			button.setAttribute('disabled', '');
		});

		instance.sortTriggers.forEach((button) => {
			button.setAttribute('disabled', '');
		});

		instance.clearTrigger.setAttribute('disabled', '');
		instance.applyTrigger.setAttribute('disabled', '');
	}

	instance.unblockUI = () => {
		// document.body.classList.remove('filtering-product');

		instance.filterTriggers.forEach((button) => {
			button.removeAttribute('disabled');
		});

		instance.sortTriggers.forEach((button) => {
			button.removeAttribute('disabled');
		});

		instance.clearTrigger.removeAttribute('disabled', '');
		instance.applyTrigger.removeAttribute('disabled', '');
	}

	/**
	 * Create and navigate to a new url by adding and removing URL search params
	 * set by the filters. Search params not related to the filters are preserved.
	 *
	 * NOTE: it's important to preserve other search params so filters can work on
	 * pages like Search, which relies on ?s=searchTerm
	 *
	 * @param {*} activeFilters DEPRECATED (not needed)
	 */
	instance.createFilterURL = () => {
		const newUrl = new URL(window.location);
		const searchParams = new URLSearchParams(newUrl.search);
		const allFilterGroups = [];

		// capture all filter groups, flagging active inputs
		instance.filterTriggers.forEach((button) => {
			const type = button.getAttribute('data-type') || null;
			const value = button.getAttribute('value') || null;
			const isActive = button.checked;

			let filterObj = { value, type, isActive }

			instance.addFilter(allFilterGroups, filterObj);
		});

		instance.sortTriggers.forEach((button) => {
			const type = button.getAttribute('data-type') || null;
			const value = button.getAttribute('value') || null;
			const isActive = button.checked;

			let filterObj = { value, type, isActive }

			instance.addFilter(allFilterGroups, filterObj);
		})

		// set search param for active filters, remove params with no active ones
		allFilterGroups.forEach(group => {
			const groupName = group.name;

			const active = group.filters.filter(f => f.isActive);

			if (active && active.length) {
				const valueString = active
										.map(f => f.value)
										.join(',');

				searchParams.set(groupName, valueString);
			}
			else {
				searchParams.delete(groupName);
			}
		});

		searchParams.set('view', instance.view);

		newUrl.search = searchParams.toString();

		swup.loadPage({
			url: newUrl.toString(),
		});
	}

	instance.resetFilters = () => {

		if (instance.filterTriggers) {
			instance.filterTriggers.forEach((button) => {
				button.checked = false;
			});
		}
	}

	instance.init = () => {
		const filterElements = document.querySelectorAll('.post-filter');
		const sortElements = document.querySelectorAll('.sort-radio');

		const clearTrigger = document.querySelector('.clear-filter');
		const applyTrigger = document.querySelector('.apply-filter');

		const viewTriggers = document.querySelectorAll('.product-archive__nav-lockup-view');

		if(
			(!filterElements && filterElements.length <= 0) ||
			(!sortElements && sortElements.length <= 0) ||
			(!clearTrigger) ||
			(!applyTrigger)
		) {
			return;
		}

		instance.filterTriggers = Array.from(filterElements);
		instance.sortTriggers = Array.from(sortElements);
		instance.clearTrigger = clearTrigger;
		instance.applyTrigger = applyTrigger;

		instance.clearTrigger.addEventListener('click', () => {
			instance.resetFilters();
			instance.applyFilters();
		});

		instance.applyTrigger.addEventListener('click', instance.applyFilters);

		instance.sortTriggers.forEach((button) => {
			button.addEventListener('change', instance.applyFilters);
		});

		if (viewTriggers.length) {
			viewTriggers.forEach((button) => {
				button.addEventListener('click', () => {
					instance.setNewView(button.dataset.view);
					instance.applyFilters();
				});
			});
		}
	}

	instance.unload = () => {

	}

	return instance;
})()



// WEBPACK FOOTER //
// ./scripts/modules/product-filtering.js